var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-button hover",class:[_vm.type, _vm.isPhone ? 'phone' : '', _vm.large ? 'large' : '', _vm.size, _vm.nr ? 'nr' : ''],style:({width: `${_vm.width}px`}),on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }